import React, { useEffect, useState } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';

import type { UserBadge } from '../../types';
import { getBadgeDetail } from './utils';

import defaultBadgeImg from '../../img/achivements/default_badge.png';

interface BadgeDisplayProps {
  badge: any;
}

const BadgeDisplay: React.FC<BadgeDisplayProps> = ({ badge }) => {
  const [tooltip, setTooltip] = useState<string>('');

  const intl = useIntl();

  const credentialImageURL = ({ object_uri: iconImage }: UserBadge) => (
    iconImage || defaultBadgeImg
  );

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = defaultBadgeImg;
  };

  useEffect(() => {
    setTooltip(getBadgeDetail('description', intl, badge) ?? '');
  }, [badge]);

  return (
    <SlTooltip>
      <div style={{ textAlign: 'center' }} slot="content">
        <span>{tooltip}</span>
      </div>
      <span className="cred-box">
        <img
          data-name="badge_image"
          loading="lazy"
          alt=""
          src={credentialImageURL(badge)}
          onError={handleError}
          className="image-16"
        />
        <div>
          {getBadgeDetail('label', intl, badge) ?? ''}
        </div>
      </span>
    </SlTooltip>
  );
};

export default BadgeDisplay;
